import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const OfferPaymentPlanSummary = ({ scheduleType, paymentPlanSummary, currencyCode, t }) => (
  <>
    {!scheduleType ? (
      <Typography variant='caption'>{t('OfferEdit.PaymentPlan.MissingSchedule')}</Typography>
    ) : (
      paymentPlanSummary && (
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <strong>{t('OfferEdit.PaymentPlan.DurationMonths')}:</strong>{' '}
            <span id={'offerPaymentPlanCard_summary_monthNo'}>{paymentPlanSummary.monthNo}</span>
          </Grid>
          <Grid item xs={12} sm={3}>
            <strong>{t('OfferEdit.PaymentPlan.MonthlyRate')}:</strong>{' '}
            <span id={'offerPaymentPlanCard_summary_firstScheduleRate'}>
              {t('NUMBER', { number: paymentPlanSummary.firstScheduleRate })} {currencyCode}
            </span>
          </Grid>
          <Grid item xs={12} sm={3}>
            <strong>{t('OfferEdit.PaymentPlan.MonthlyRateWithTax')}:</strong>{' '}
            <span id={'offerPaymentPlanCard_summary_firstScheduleRateWithTax'}>
              {t('NUMBER', { number: paymentPlanSummary.firstScheduleRateWithTax })} {currencyCode}
            </span>
          </Grid>
          <Grid item xs={12} sm={3}>
            <strong>{t('OfferEdit.PaymentPlan.Total')}:</strong>{' '}
            <span id={'offerPaymentPlanCard_summary_totalScheduleAmount'}>
              {t('NUMBER', { number: paymentPlanSummary.totalScheduleAmount })} {currencyCode}
            </span>
          </Grid>
        </Grid>
      )
    )}
  </>
);

OfferPaymentPlanSummary.propTypes = {
  t: PropTypes.func.isRequired,
  paymentPlanSummary: PropTypes.object,
  currencyCode: PropTypes.string.isRequired,
  scheduleType: PropTypes.object
};

export default withTranslation()(memo(OfferPaymentPlanSummary));
